import { RouteView } from '@/layouts'
//数据分析部分
export const dashboardRouter = [
  {
    path: '/dashboard',
    redirect: '/dashboard/managePandect',
    component: RouteView,
    meta: { title: '数据', keepAlive: true, icon: 'bar-chart' },
    name:"dashboardGroup",
    children: [
      {
        path: '/dashboard/group',
        component: RouteView,
        redirect: '/dashboard/managePandect',
        meta: { title: '数据罗盘', keepAlive: true },
        name:"dashboardPandect",
        children: [
          {
            path: '/dashboard/managePandect',
            name: 'ManagePandect',
            component: () => import('@/views/dashboard/ManagePandect'),
            meta: { title: '经营总览', keepAlive: true }
          },
          {
            path: '/dashboard/transactionData',
            name: 'TransactionData',
            component: () => import('@/views/dashboard/TransactionData'),
            meta: { title: '交易数据', keepAlive: true }
          },
          {
            path: '/dashboard/productData',
            name: 'ProductData',
            component: () => import('@/views/dashboard/ProductData'),
            meta: { title: '商品数据', keepAlive: true }
          },
          {
            path: '/dashboard/dataFlow',
            name: 'DataFlow',
            component: () => import('@/views/dashboard/DataFlow'),
            meta: { title: '流量数据', keepAlive: true }
          },
          {
            path: '/dashboard/usersData',
            name: 'UsersData',
            component: () => import('@/views/dashboard/UsersData'),
            meta: { title: '用户数据', keepAlive: true }
          }
        ]
      }
    ]
  }
]